<template>
  <div>
    <wc-page-title title='Uncollectible invoices'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Report Results'
            titleIcon='mdi-finance'
            showSearch
            v-model='search'
          >
            <v-data-table
              :items='invs'
              :headers='headers'
              :loading='isLoading'
              dense
              :items-per-page='-1'
              hide-default-footer
              :search='search'
              @click:row='openInvoice'
            >
              <template v-slot:item.number='{ item }'>
                {{ item.number }}
                <v-icon small v-if="item.status === 'on_hold'" color='error'>{{$icons.hold.icon}}</v-icon>
              </template>
              <template v-slot:item.original_amount='{ item }'>
                {{ item.original_amount | dec }}
              </template>
              <template v-slot:item.amount_os='{ item }'>
                {{ item.amount_os | dec }}
              </template>
              <template v-slot:item.action_1='{ item }'>
                <strong v-if='item.action_1' class='error--text'>A1</strong>
              </template>
              <template v-slot:item.action_2='{ item }'>
                <strong v-if='item.action_2' class='error--text'>A2</strong>
              </template>
              <template v-slot:item.action_3='{ item }'>
                <strong v-if='item.action_3' class='error--text'>A3</strong>
              </template>
              <template v-slot:item.action_4='{ item }'>
                <strong v-if='item.action_4' class='error--text'>A4</strong>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import miscServices from '@/services/misc';
import formRules from '@/mixins/formRules';
import _ from 'lodash';

export default {
  name: 'unpaid-invoices',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    isFormValid: false,
    invs: [],
    timeFrame: '',
    search: '', 
    ignoreSmallBalances: true,
    headers: [
      { text: 'Due date', value: 'date_due' },
      { text: 'Number', value: 'number' },
      { text: 'Bill to', value: 'bill_to_display' },
      { text: 'Action 1', value: 'action_1', align: 'center' },
      { text: 'Action 2', value: 'action_2', align: 'center' },
      { text: 'Action 3', value: 'action_3', align: 'center' },
      { text: 'Action 4', value: 'action_4', align: 'center' },
      { text: 'Org Amt', value: 'original_amount', align: 'right' },
      { text: 'OS', value: 'amount_os', align: 'right' }
    ]
  }),
  computed: {
    reportTotal () {
      return _.sumBy(this.invs, 'amount_os');
    }
  },
  mounted () {
    this.runReport()
  },
  methods: {
    async runReport () {
      this.isLoading = true;
      this.invs = await accountingAPI.getUncollectibleInvoices();
      this.isLoading = false;
    },
    openInvoice (inv) {
      miscServices.openInNewTab({ name: 'InvoiceOverview', params: { id: inv.id } });
    }
  }
}
</script>
